import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

const PageNotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] text-center px-4 font-body">
      <h1 className="text-2xl md:text-3xl font-semibold tracking-tight text-gray-950 font-heading my-2">
        Seite nicht gefunden
      </h1>
      <p className="text-gray-600 mb-6 max-w-md">
        Leider konnte die gewünschte Seite nicht gefunden werden. 
        Bitte überprüfe den Link oder kehre zur Startseite zurück.
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-x-2 py-2 px-4 bg-sky-600 hover:bg-sky-700 text-white rounded-full text-sm transition group"
      >
        <FiArrowLeft />
        Zur Startseite
      </Link>
    </div>
  );
};

export default PageNotFound;
